import plugin from '@core/plugins/lib';
import ButtonPendingState from './button-pending-state.js';

const ELEMENT_SELECTOR = '[data-button-pending-state]';
const PLUGIN_NAME = 'ButtonPendingState';
const elements = document.querySelectorAll(ELEMENT_SELECTOR);

if (elements.length) {
	plugin(PLUGIN_NAME, ButtonPendingState);
	$(elements)[PLUGIN_NAME]();
}



// WEBPACK FOOTER //
// ./client/src/core/components/button-pending-state/index.js